export default class GPT {
    constructor() {
        const _ = this;
        _.googletag_element_ids = [];
        window.googletag = window.googletag || { cmd: [] };

        // Init GPT
        window.googletag.cmd.push(function () {
            window.googletag.pubads().enableLazyLoad({
                fetchMarginPercent: 150,
                renderMarginPercent: 75,
                mobileScaling: 1.5
            });

            window.googletag.enableServices();
        });

        window.googletag.cmd.push(function () {
            _.publishSlot();
        });
    }

    reload() {
        const _ = this;

        window.googletag.cmd.push(function () {
            _.publishSlot();
        });
    }

    publishSlot() {
        const _ = this;
        let mobile = window.matchMedia('(min-width: 0px) and (max-width: 700px)');

        function googletagDefineSlot(slot_id, element_id, all_sizes, sizes) {
            // Prevent repeat definitions
            if (_.googletag_element_ids.includes(element_id)) {
                return null;
            }

            _.googletag_element_ids.push(element_id);

            if (!window.googletag.sizeMapping || !slot_id || !element_id || !all_sizes || !sizes) {
                return null;
            }

            var _YB = {
                ab: function () {
                    return _YB.dool ? 'b' : 'a' + Math.floor(Math.random() * 10);
                },
                dc: function () {
                    return _YB.dool ? 'd' : 'c' + Math.floor(Math.random() * 20);
                },
                mx: function () {
                    return !_YB.dool ? 'x' : 'm' + Math.floor(Math.random() * 180);
                },
                tt: function () {
                    return 'tt' + Math.floor(Math.random() * 10);
                },
                dool: Math.random() >= 0.1
            };

            var _yt = new Date();
            var yb_th = _yt.getUTCHours() - 8;
            var yb_tm = _yt.getUTCMinutes();
            var yb_wd = _yt.getUTCDay();
            if (yb_th < 0) {
                yb_th = 24 + yb_th;
                yb_wd -= 1;
            }
            if (yb_wd < 0) {
                yb_wd = 7 + yb_wd;
            }

            var size_mapping = window.googletag.sizeMapping();

            all_sizes.forEach(function (size) {
                size_mapping = size_mapping.addSize(size[0], size[1]);
            });

            var YBmapping = size_mapping.build();

            return window.googletag.defineSlot(slot_id, sizes, element_id)
                .defineSizeMapping(YBmapping)
                .setTargeting('yb_ab', _YB.ab())
                .setTargeting('yb_dc', _YB.dc())
                .setTargeting('yb_mx', _YB.mx())
                .setTargeting('yb_tt', _YB.tt())
                .setTargeting('yb_ff', '' + Math.round(Math.random()))
                .setTargeting('yb_th', yb_th.toString())
                .setTargeting('yb_tm', yb_tm.toString())
                .setTargeting('yb_wd', yb_wd.toString())
                .addService(googletag.pubads());
        }

        function googletagGetUniqueElementId(element_id, blacklist) {
            var new_id;
            var index = 0;

            while (true) {
                new_id = element_id + (index > 0 ? '-' + index : '');

                if (!document.querySelector('#' + new_id) && !blacklist.includes(new_id)) {
                    break;
                }

                index += 1;
            }

            return new_id;
        }

        function googletagReplacePlaceholderSlot(slot_placeholder, slot_configuration) {

            var slot_id = slot_placeholder.dataset.gptName;
            var slot = Object.assign({}, slot_configuration ? slot_configuration[slot_id] : {});

            if (!slot) {
                slot_placeholder.classList.add("gpt--loaded");

                return;
            }

            // Define Google Publisher Tag slot
            var new_element_id = "";
            if (mobile.matches) {
                new_element_id = googletagGetUniqueElementId(slot.mobil_element, _.googletag_element_ids);
            }
            else
            {
                new_element_id = googletagGetUniqueElementId(slot.element_id, _.googletag_element_ids);
            }
            var googletag_slot = googletagDefineSlot(mobile.matches ? slot.mobileGptUrl : slot.gptUrl, new_element_id, mobile.matches ? slot.mobile_all_sizes : slot.all_sizes, mobile.matches ? slot.mobileSize : slot.size);


            if (!googletag_slot) {
                slot_placeholder.classList.add('gpt--loaded');

                return;
            }

            var slot_element_id = googletag_slot.getSlotElementId();
            slot_placeholder.setAttribute('id', slot_element_id);

            // Register the slot as ready and fetch an ad
            window.googletag.display(googletag_slot);

            // Refresh slot to load ad, if element ID was altered
            if (typeof window.Yieldbird !== 'undefined') {
                window.Yieldbird.cmd.push(function () {
                    Yieldbird.setGPTTargeting([googletag_slot]);
                    window.googletag.pubads().refresh([googletag_slot]);
                });
            }

            slot_placeholder.classList.add('gpt--loaded');
        }

        document.querySelectorAll('[data-gpt-name]').forEach(item => {
            googletagReplacePlaceholderSlot(item, this.definedSlots());
        });
    }

    definedSlots() {
        return {
            'billboard_1': {
                'all_sizes': [[[930, 0], [[930, 180], [728, 90], [930, 240], [930, 300], [930, 600]]], [[768, 0], [[728, 90]]], [[0, 0], []]],
                'size': [[930, 180], [728, 90], [930, 240], [930, 300], [930, 600]],
                'gptUrl': `/21809957681,191527249/Gaffa/${window.domainConfig}/billboard_1`,
                'mobileSize': [[300, 250], [320, 100], [320, 160], [320, 320], [336, 280]],
                'mobileGptUrl': `/21809957681,191527249/Gaffa/${window.domainConfig}/mobile_1`,
                'mobile_all_sizes': [[[767, 0], []], [[0, 0], [[300, 250], [320, 320], [320, 160], [320, 100], [336, 280]]]],
                'element_id': 'div-gpt-ad-billboard_1',
                'mobil_element': 'div-gpt-ad-mobile_1'
            },
            'billboard_2': {
                'size': [[728, 90], [930, 180], [930, 240], [930, 300], [930, 600]],
                'all_sizes': [[[930, 0], [[930, 180], [728, 90], [930, 240], [930, 300], [930, 600]]], [[768, 0], [[728, 90]]], [[0, 0], []]],
                'gptUrl': `/21809957681,191527249/Gaffa/${window.domainConfig}/billboard_2`,
                'mobileSize': [[300, 250], [320, 100], [320, 160], [320, 320], [336, 280]],
                'mobileGptUrl': `/21809957681,191527249/Gaffa/${window.domainConfig}/mobile_2`,
                'mobile_all_sizes': [[[767, 0], []], [[0, 0], [[300, 250], [320, 320], [320, 160], [320, 100], [336, 280]]]],
                'element_id': 'div-gpt-ad-billboard_2',
                'mobil_element': 'div-gpt-ad-mobile_2'
            },
            'billboard_3': {
                'all_sizes': [[[930, 0], [[930, 180], [728, 90], [930, 240], [930, 300], [930, 600]]], [[768, 0], [[728, 90]]], [[0, 0], []]],
                'size': [[930, 180], [728, 90], [930, 240], [930, 300], [930, 600]],
                'gptUrl': `/21809957681,191527249/Gaffa/${window.domainConfig}/billboard_3`,
                'mobileSize': [[300, 250], [320, 100], [320, 160], [320, 320], [336, 280]],
                'mobileGptUrl': `/21809957681,191527249/Gaffa/${window.domainConfig}/mobile_3`,
                'mobile_all_sizes': [[[767, 0], []], [[0, 0], [[300, 250], [320, 320], [320, 160], [320, 100], [336, 280]]]],
                'element_id': 'div-gpt-ad-billboard_3',
                'mobil_element': 'div-gpt-ad-mobile_3'
            },
            'billboard_4': {
                'size': [[728, 90], [930, 180], [930, 240], [930, 300], [930, 600]],
                'all_sizes': [[[930, 0], [[930, 180], [728, 90], [930, 240], [930, 300], [930, 600]]], [[768, 0], [[728, 90]]], [[0, 0], []]],
                'gptUrl': `/21809957681,191527249/Gaffa/${window.domainConfig}/billboard_4`,
                'mobileSize': [[300, 250], [320, 100], [320, 160], [320, 320], [336, 280]],
                'mobileGptUrl': `/21809957681,191527249/Gaffa/${window.domainConfig}/mobile_4`,
                'mobile_all_sizes': [[[767, 0], []], [[0, 0], [[300, 250], [320, 320], [320, 160], [320, 100], [336, 280]]]],
                'element_id': 'div-gpt-ad-billboard_4',
                'mobil_element': 'div-gpt-ad-mobile_4'
            },
            'sky_1': {
                'size': [[300, 600], [160, 600]],
                'all_sizes': [[[1500, 0], [[160, 600], [300, 600]]], [[1200, 0], [[160, 600]]], [[0, 0]]],
                'gptUrl': `/21809957681,191527249/Gaffa/${window.domainConfig}/sticky_1`,
                'mobileSize': [[300, 250], [320, 100], [320, 160], [320, 320], [336, 280]],
                'mobileGptUrl': `/21809957681,191527249/Gaffa/${window.domainConfig}/mobile_5`,
                'mobile_all_sizes': [[[767, 0], []], [[0, 0], [[300, 250], [320, 320], [320, 160], [320, 100], [336, 280]]]],
                'element_id': 'div-gpt-ad-sticky_1',
                'mobil_element': 'div-gpt-ad-mobile_5'
            },
            'sky_2': {
                'size': [[300, 600], [160, 600]],
                'all_sizes': [[[1500, 0], [[160, 600], [300, 600]]], [[1200, 0], [[160, 600]]], [[0, 0]]],
                'gptUrl': `/21809957681,191527249/Gaffa/${window.domainConfig}/sticky_2`,
                'mobileSize': [[300, 250], [320, 100], [320, 160], [320, 320], [336, 280]],
                'mobileGptUrl': `/21809957681,191527249/Gaffa/${window.domainConfig}/mobile_6`,
                'mobile_all_sizes': [[[767, 0], []], [[0, 0], [[300, 250], [320, 320], [320, 160], [320, 100], [336, 280]]]],
                'element_id': 'div-gpt-ad-sticky_2',
                'mobil_element': 'div-gpt-ad-mobile_6'
            },
            'rectangle_1': {
                'all_sizes': [[[768,0],[[300,250]]],[[0,0],[]]],
                'size': [[300, 250]],
                'gptUrl': `/21809957681,191527249/Gaffa/${window.domainConfig}/rectangle_1`,
                'mobileSize': [[300, 250], [320, 100], [320, 160], [320, 320], [336, 280]],
                'mobileGptUrl': `/21809957681,191527249/Gaffa/${window.domainConfig}/mobile_7`,
                'mobile_all_sizes': [[[767, 0], []], [[0, 0], [[300, 250], [320, 320], [320, 160], [320, 100], [336, 280]]]],
                'element_id': 'div-gpt-ad-rectangle_1',
                'mobil_element': 'div-gpt-ad-mobile_7'
            },
            'rectangle_2': {
                'all_sizes': [[[768, 0], [[300, 250]]], [[0, 0], []]],
                'size': [[300, 250]],
                'gptUrl': `/21809957681,191527249/Gaffa/${window.domainConfig}/rectangle_2`,
                'mobileSize': [[300, 250], [320, 100], [320, 160], [320, 320], [336, 280]],
                'mobileGptUrl': `/21809957681,191527249/Gaffa/${window.domainConfig}/mobile_8`,
                'mobile_all_sizes': [[[767, 0], []], [[0, 0], [[300, 250], [320, 320], [320, 160], [320, 100], [336, 280]]]],
                'element_id': 'div-gpt-ad-rectangle_2',
                'mobil_element': 'div-gpt-ad-mobile_8'
            },
            'rectangle_3': {
                'all_sizes': [[[768, 0], [[300, 250]]], [[0, 0], []]],
                'size': [[300, 250]],
                'gptUrl': `/21809957681,191527249/Gaffa/${window.domainConfig}/rectangle_3`,
                'mobileSize': [[300, 250], [320, 100], [320, 160], [320, 320], [336, 280]],
                'mobileGptUrl': `/21809957681,191527249/Gaffa/${window.domainConfig}/mobile_9`,
                'mobile_all_sizes': [[[767, 0], []], [[0, 0], [[300, 250], [320, 320], [320, 160], [320, 100], [336, 280]]]],
                'element_id': 'div-gpt-ad-rectangle_3',
                'mobil_element': 'div-gpt-ad-mobile_9'
            },
            'rectangle_4': {
                'all_sizes': [[[768, 0], [[300, 250]]], [[0, 0], []]],
                'size': [[300, 250]],
                'gptUrl': `/21809957681,191527249/Gaffa/${window.domainConfig}/rectangle_4`,
                'mobileSize': [[300, 250], [320, 100], [320, 160], [320, 320], [336, 280]],
                'mobileGptUrl': `/21809957681,191527249/Gaffa/${window.domainConfig}/mobile_10`,
                'mobile_all_sizes': [[[767, 0], []], [[0, 0], [[300, 250], [320, 320], [320, 160], [320, 100], [336, 280]]]],
                'element_id': 'div-gpt-ad-rectangle_4',
                'mobil_element': 'div-gpt-ad-mobile_10'
            },
            'rectangle_5': {
                'all_sizes': [[[768, 0], [[300, 250]]], [[0, 0], []]],
                'size': [[300, 250]],
                'gptUrl': `/21809957681,191527249/Gaffa/${window.domainConfig}/rectangle_5`,
                'mobileSize': [[300, 250], [320, 100], [320, 160], [320, 320], [336, 280]],
                'mobileGptUrl': `/21809957681,191527249/Gaffa/${window.domainConfig}/mobile_11`,
                'mobile_all_sizes': [[[767, 0], []], [[0, 0], [[300, 250], [320, 320], [320, 160], [320, 100], [336, 280]]]],
                'element_id': 'div-gpt-ad-rectangle_5',
                'mobil_element': 'div-gpt-ad-mobile_11'
            },
            'topscroll': {
                'all_sizes': [[[930,0],[[1,2]]],[[0,0],[]]],
                'size': [[1,2]],
                'gptUrl': `/21809957681,191527249/Gaffa/${window.domainConfig}/topscroll`,
                'mobileSize': [[1, 2]],
                'mobileGptUrl': `/21809957681,191527249/Gaffa/${window.domainConfig}/topscroll_mobile`,
                'mobile_all_sizes': [[[929, 0], []], [[0, 0], [[1, 2]]]],
                'element_id': 'div-gpt-ad-topscroll',
                'mobil_element': 'div-gpt-ad-topscroll_mobile'
            },
            'anchor': {
                'all_sizes': [[[930, 0], [[930, 180], [728, 90]]], [[768, 0], [[728, 90]]], [[0, 0], [[320, 80], [320, 100], [320, 50]]]],
                'size': [[320, 80], [320, 100], [320, 50], [728, 90], [930, 180]],
                'gptUrl': `/21809957681,191527249/Gaffa/${window.domainConfig}/anchor`,
                'mobileSize': [[320, 80], [320, 100], [320, 50], [728, 90], [930, 180]],
                'mobileGptUrl': `/21809957681,191527249/Gaffa/${window.domainConfig}/anchor`,
                'mobile_all_sizes': [[[930, 0], [[930, 180], [728, 90]]], [[768, 0], [[728, 90]]], [[0, 0], [[320, 80], [320, 100], [320, 50]]]],
                'element_id': 'div-gpt-ad-anchor',
                'mobil_element': 'div-gpt-ad-anchor'
            }
        }
    }
}
